import React, {Component} from 'react';
import ValuesRequestView from "./ValuesRequestView";
import {OrderBorrowerService} from "../../../service/ptt/OrderBorrowerService";
import ConfirmationMessage from "../../../components/confirmationMessage";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import {
    SET_ORDER_BORROWER_ROUTE,
    UPDATE_ORDER_BORROWER_ROUTE,
    VALUES_REQUEST_ROUTE
} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";

export default class ValuesRequestContainer extends Component {
    constructor(props) {
        super(props);

        this.orderBorrowerService = new OrderBorrowerService();

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };
        this.openConfirmation = () => {
            if (this.confirmationRef) {
                this.closeContextMenu();
                this.confirmationRef.openConfirmationMessage()
            }
        };
        this.getOrderBorrowerList = this.getOrderBorrowerList.bind(this);
        this.loading = this.loading.bind(this);
        this.setOrderBorrower = this.setOrderBorrower.bind(this);
        this.editOrderActionTemplate = this.editOrderActionTemplate.bind(this);
        this.deleteOrder = this.deleteOrder.bind(this);
        this.handleSelectOrder = this.handleSelectOrder.bind(this);
        this.fillOrderBorrowerList = this.fillOrderBorrowerList.bind(this);
        this.updateOrderBorrower = this.updateOrderBorrower.bind(this);
        this.deleteOrderPreparation = this.deleteOrderPreparation.bind(this);

        this.state = {
            isLoading: true,
            anchorEl: null,
            orderBorrowerList: this.getOrderBorrowerList(),
            selectedOrder: '',
            deleteOrder: '',
            contextMenuItems: [
                {
                    label: 'Editar',
                    command: this.updateOrderBorrower,
                },
                {
                    label: 'Eliminar',
                    command: this.openConfirmation,
                }
            ]
        };
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    openContextMenu = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    closeContextMenu = () => {
        this.setState({anchorEl: null});
    };

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    fillOrderBorrowerList(orderBorrower) {
        this.setState({
            orderBorrowerList: orderBorrower,
            isLoading: false
        })
    }

    getOrderBorrowerList() {
        this.loading();
        return this.orderBorrowerService.getOrderBorrowerList(
        ).then(
            orderBorrower =>
                this.fillOrderBorrowerList(orderBorrower)
        );
    }

    setOrderBorrower() {
        this.props.history.push({
            pathname: SET_ORDER_BORROWER_ROUTE,
            state: {
                returnPath: VALUES_REQUEST_ROUTE,
            },
        });
    }

    updateOrderBorrower() {
        this.props.history.push({
            pathname: UPDATE_ORDER_BORROWER_ROUTE,
            state: {
                returnPath: VALUES_REQUEST_ROUTE,
                orderBorrower: this.state.selectedOrder,
            },
        });
    }

    deleteOrderPreparation() {
        this.setState({
            deleteOrder: this.state.selectedOrder,
        });
        this.closeContextMenu();
        if (this.confirmationRef) {
            this.confirmationRef.openConfirmationMessage()
        }
    }

    editOrderActionTemplate() {
        return (
            <div style={{textAlign: 'center'}}>
                <button className="p-link"
                        onClick={this.openContextMenu}>
                    <span className="layout-topbar-icon pi pi-ellipsis-v"/>
                </button>
                <Menu id="long-menu"
                      anchorEl={this.state.anchorEl}
                      open={Boolean(this.state.anchorEl)}
                      onClose={this.closeContextMenu}>
                    <MenuItem
                        onClick={this.updateOrderBorrower}>
                        Editar
                    </MenuItem>
                    <MenuItem onClick={this.deleteOrderPreparation}>
                        Eliminar
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    deleteOrder() {
        this.loading();
        this.orderBorrowerService.deleteOrderBorrower(this.state.deleteOrder.folio)
            .then(orderBorrower => this.fillOrderBorrowerList(orderBorrower));
    }

    handleSelectOrder(event) {
        this.setState({
            selectedOrder: event.value,
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Está seguro que desea eliminar la postura prestataria?"
                                            action={this.deleteOrder}/>;
        return (
            <ValuesRequestView
                isLoading={this.state.isLoading}
                messagesGrowl={messagesGrowl}
                confirmationMsg={this.confMsg}
                orderBorrowerList={this.state.orderBorrowerList}
                handleSelectOrder={this.handleSelectOrder}
                selectedOrder={this.state.selectedOrder}
                editOrderActionTemplate={this.editOrderActionTemplate}
                getOrderBorrowerList={this.getOrderBorrowerList}
                setOrderBorrower={this.setOrderBorrower}
            />
        );
    }
}
